export const commonStyles = {
  clearButton: {
    textDecoration: "none",
    textTransform: "none",
    color: "rgba(85, 85, 85, 1)",
    fontWeight: "500",
    fontSize: "13px",
    background: "#FFFFFF",
    borderRadius: 2,
    px: 2,
    py: "7px",
    width: "auto",
    height: "38px",
    border: "1px solid rgba(204, 210, 222, 1)",
    "&:hover": {
      background: "#E0E0E0",
    },
  },
  saveButton: {
    textDecoration: "none",
    textTransform: "none",
    color: "#FFFFFF !important",
    fontWeight: "500",
    fontSize: "13px",
    background: "rgba(255, 94, 0, 0.75)",
    borderRadius: 2,
    px: 2,
    py: "7px",
    width: "auto",
    height: "38px",
    "&:hover": {
      background: "#E95500 !important",
    },
    "&.Mui-disabled": {
      backgroundColor: "#E95500",
    },
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      fontSize: 13,
      fontWeight: 400,
      borderRadius: 2,
      borderColor: "#CCD2DE",
      borderWidth: "1px",
      transition: "border-color 0.3s ease",
      padding: 0,
    },
    "& .MuiOutlinedInput-input": {
      p: "15px 35px 15px 15px",
      "&::placeholder": {
        color: "#555555",
        fontSize: 13,
        fontWeight: 400,
      },
    },
  },
  hideScroll: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
  },
  customSelect: {
    control: (provided) => ({
      ...provided,
      border: "1px solid #CCD2DE",
      padding: "2px",
      borderRadius: 8,
      boxShadow: "none",
      fontSize: 13,
      "&:hover": {
        borderColor: "#CCD2DE",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#555555",
      fontSize: 13,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333333",
      fontSize: 13,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 8,
      border: "1px solid #CCD2DE",
      padding: "5px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 2,
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#333333" : "#555555",
      backgroundColor: state.isSelected ? "#DDE8FF" : "#FFFFFF",
      fontSize: 13,
      borderRadius: 2,
      padding: "10px 12px",
      "&:hover": {
        backgroundColor: state.isSelected ? "#DDE8FF" : "#F2F2F2",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  },
  textInfo: {
    border: 1,
    borderColor: "#CCD2DE",
    px: 1.5,
    py: 0.25,
    borderRadius: "9px",
  },
  phoneInput: {
    buttonStyle: {
      background: "#f4f4f4",
      border: "1px solid #E6EBF7",
      backgroundColor: "#F5F7FB",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
    },
    inputStyle: {
      padding: "20px 10px 20px 50px",
      border: "1px solid #CCD2DE",
      width: "100%",
    },
    containerStyle: {
      borderRadius: "8px",
    },
  },
  tabs: {
    marginTop: 2,
    backgroundColor: "#F1F4FA",
    width: "fit-content",
    borderRadius: "6px",
    minHeight: 36,
    ".MuiTabs-indicator": {
      display: "none",
    },
    ".MuiTabs-scroller": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginX: 0.5,
    },
  },
  tab: {
    fontSize: 14,
    fontWeight: 400,
    textTransform: "none",
    padding: "2px 8px",
    color: "#757B93",
    borderRadius: "8px",
    minHeight: 30,
    "&.Mui-selected": {
      backgroundColor: "#fff",
      color: "#333333",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    },
  },
  loginButton: {
    mt: 1,
    padding: 1.5,
    textTransform: "none",
  },
  newAuthLoginButton: {
    mt: 1,
    padding: 1,
    backgroundColor: "#25304c",
    "&:hover": {
      backgroundColor: "#25304c",
    },
    "&.Mui-disabled": {
      backgroundColor: "#7c8293",
    },
  },
  skeletonStyle: {
    backgroundColor: "#F3F6FD",
    borderRadius: "6px",
  },
  addBtn: {
    textTransform: "none",
    color: "#656E7F",
    border: 0,
    backgroundColor: "#F1F4FA",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 2,
    padding: "4px 10px",
    "&:hover": {
      transition: "width 0.5s ease-in-out",
      border: 0,
    },
  },
  favBtn: {
    minWidth: "auto",
    p: "10px",
    borderColor: "#D1D9EF",
    "&:hover": {
      borderColor: "#666",
    },
  },
  cardContainer: {
    mt: 1.2,
    border: "1px solid #F1F4FA",
    height: "150px",
    borderRadius: 3,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    transition: "all 0.3s ease",
    "&:hover": {
      animation: "popZoom 0.4s forwards",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    "@keyframes popZoom": {
      "0%": {
        transform: "scale(1)",
      },
      "50%": {
        transform: "scale(1.05)",
      },
      "100%": {
        transform: "scale(1.03)",
      },
    },
  },
  card: {
    mt: 1.2,
    border: "1px solid #E0E6ED",
    minHeight: "200px",
    borderRadius: 3,
    padding: "10px !important",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
      border: "1px solid #D0D7E2",
    },
  },
  commonCard: {
    borderRadius: 2,
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  },
  stopButton: {
    color: "#fff",
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 600,
    padding: "7px 13px",
    width: "135px",
    borderRadius: "6px",
    boxShadow: "none",
    transition: "background-color 0.3s ease",
    "&.Mui-disabled": {
      backgroundColor: "#d46a6a",
      color: "#f1f1f1",
      opacity: 1,
    },
  },
  dashedContainer: {
    border: "1px dashed #D1D9EF",
    borderRadius: 3,
    textAlign: "center",
  },
  forgotPasswordLink: {
    mt: 2,
    color: "#4280FF",
    fontSize: 13,
    display: "flex",
    justifyContent: "flex-end",
    textDecoration: "none",
    cursor: "pointer",
  },
  signupLink: {
    color: "#4280FF",
    fontWeight: "bold",
    cursor: "pointer",
    ":hover": { textDecoration: "underline" },
  },
  filterButtonStyle: {
    px: 1.05,
    py: 0,
    borderRadius: 2,
    color: "#D1D9EF",
    border: 1,
    "&:hover": {
      borderColor: "#666",
    },
  },
  refreshButtonStyle: {
    borderRadius: 2,
    px: 1.25,
    color: "#D1D9EF",
    border: 1,
    "&:hover": {
      borderColor: "#666",
    },
  },
  summaryCardContainer: {
    py: 3,
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: 2,

    "@media (max-width: 1300px)": {
      gridTemplateColumns: "repeat(6, 1fr)",
    },
    "@media (max-width: 1200px)": {
      gridTemplateColumns: "repeat(5, 1fr)",
    },
    "@media (max-width: 1020px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
  },
  commonSelectStyle: (val) => {
    return {
      control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: val !== 1 ? "#D72917" : "skyblue",
        boxShadow:
          val !== 1
            ? state.isFocused
              ? "0 0 0 0.5px #D72917"
              : "none"
            : state.isFocused
            ? "0 0 0 0.5px skyblue"
            : "none",
        "&:hover": {
          borderColor: val !== 1 ? "#D72917" : "skyblue",
        },
      }),
    };
  },
  typeSelect: {
    width: "100%",
    fontSize: 14,
    fontWeight: 400,
    borderColor: "#D1D9EF",
    borderRadius: 1,
    color: "#9E9FA1",
    "& .MuiSelect-select": {
      padding: "10px 14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: 2,
    },
  },
  baseButtonStyles: (variant, brandColor, hoverColor, disabledBgColor) => {
    return {
      color: variant === "contained" ? "white" : "#333333",
      fontSize: variant === "text" ? 11 : 13,
      fontWeight: 500,
      borderRadius: 2,
      textTransform: "capitalize",
      textWrap: "nowrap",
      boxShadow: "none",
      backgroundColor: variant === "contained" ? brandColor : "transparent",
      borderColor: variant === "outlined" ? "#CCD2DE" : "inherit",
      "&:hover": {
        backgroundColor: hoverColor,
        boxShadow: "none",
        borderColor: variant === "outlined" ? "#a2a4a8" : "inherit",
        transition: "width 0.5s ease-in-out",
      },
      "&.Mui-disabled": {
        color: variant === "contained" ? "white" : "default",
        backgroundColor: disabledBgColor,
      },
    };
  },
  phoneInput: {
    buttonStyle: {
      background: "#f4f4f4",
      padding: "10px 3px",
      border: "1px solid #E6EBF7",
      backgroundColor: "#F5F7FB",
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
    },
    inputStyle: {
      width: "100%",
      paddingTop: "20px",
      paddingBottom: "20px",
      border: "1px solid #CCD2DE",
    },
    containerStyle: {
      borderRadius: "8px",
    },
  },
  emptyState: {
    container: {
      my: 1,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyItems: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 2,
      p: 3,
      position: "relative",
    },
    innerContainer: {
      fontSize: 20,
      fontWeight: 500,
      color: "#555555",
      textTransform: "capitalize",
      textAlign: "center",
      position: "absolute",
      top: 90,
      left: "50%",
      transform: "translateX(-50%)",
    },
  },
  textFieldSyle: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      borderColor: "#CCD2DE",
      borderWidth: "1px",
    },
    "& .MuiOutlinedInput-input": {
      paddingX: 1.5,
      paddingY: 1,
      "&::placeholder": {
        color: "#8792A7",
        fontSize: 12,
        fontWeight: 400,
      },
    },
  },
  loadingContainer: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
  menu: {
    marginTop: 1,
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    minWidth: "180px",
    minHeight: "110px",
    borderRadius: "8px",
    border: "1px solid #CCD2DE",
  },
  menuItem: {
    m: 0.5,
    height: "40px",
    borderRadius: "8px",
    fontWeight: 400,
    color: "#333333",
    fontSize: "14px",
    "&:hover": {
      background: "#DDE8FF",
    },
  },
  iconBtn: {
    minWidth: "auto",
    p: "10px",
    borderColor: "#D1D9EF",
    "&:hover": {
      borderColor: "#666",
    },
  },
  popoverCard: {
    mainContainer: {
      bgcolor: "white",
      color: "black",
      "& .MuiTooltip-arrow": {
        color: "white",
      },
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      p: 0,
      maxWidth: "none",
      border: "1px solid #e0e0e0",
    },
  },
  popUpcontainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bgcolor: "#F1F4FA",
    borderBottom: "1px solid #e3e6f0",
    padding: "1.1rem 2rem !important",
  },
  alertWarning: {
    bgcolor: "rgba(255, 193, 7, 0.15)",
    border: "1px solid #FFA000",
    color: "black",
    borderRadius: "4px",
    px: 2,
    py: 1,
    mb: 2,
  },
  ragCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #E0E6ED",
    borderRadius: 3,
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
      border: "1px solid #D0D7E2",
    },
  },
  uploadContainer: {
    border: "2px dashed #ccc",
    borderRadius: 2,
    padding: 3,
    textAlign: "center",
    cursor: "pointer",
    bgcolor: "#f9f9f9",
    "&:hover": {
      bgcolor: "#f5f5f5",
    },
    mb: 2,
  },
  tableRowText: {
    maxWidth: "300px",
    mx: "auto",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
    lineHeight: 1.4,
  },
  topUpButton: {
    borderRadius: "30px",
    padding: "12px 28px",
    fontSize: "1rem",
    fontWeight: 600,
    boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
    background: "linear-gradient(45deg, #FF6A00 30%, #FFA500 90%)",
    "&:hover": {
      background: "linear-gradient(45deg, #e95e00 30%, #ff9900 90%)",
    },
  },
};

export const alertStyles = {
  container: {
    my: 2,
    p: 2,
    borderRadius: 2,
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  innerContainer: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
  },
};

// Common Searchable Select
export const searchableSelectStyle = {
  container: {
    "& .MuiAutocomplete-endAdornment": {
      top: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  inputStyles: {
    "& .MuiOutlinedInput-root": {
      fontSize: 13,
      fontWeight: 400,
      padding: "4.3px 4px 4.3px 5px",
      borderRadius: 2,
      "& fieldset": {
        borderColor: "#D1D9EF",
      },
      "&:hover fieldset": {
        borderColor: "#181818",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#181818",
        border: 1,
      },
    },
  },
};

// Common Searchbar
export const searchBarStyles = {
  width: 230,
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    borderWidth: 1,
    fontSize: 14,
    fontWeight: 400,
    height: 36,
    "& fieldset": {
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: "#2F353E",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2F353E",
      borderWidth: 1,
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: 1.5,
    pl: 0.5,
    "&::placeholder": {
      color: "#9E9FA1",
      fontSize: 14,
      fontWeight: 400,
    },
  },
};
